// extracted by mini-css-extract-plugin
module.exports = {"button":"backButton_button__FD0jf","text":"backButton_text__2Pids"};